import * as React from "react";
import ClientTable from "./ClientTable";
import DetailTable from "./DetailTable";
import ItemAsegurado from "./ItemAsegurado";
import PaymentMethod from "./PaymentMethod";
import Footer from "./Footer";
import Header from "./Header";
import "./modal-poliza.scss";

var ModalPoliza = function ModalPoliza(props) {
  var poliza = props.poliza,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      onClose = props.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal fade bd-example-modal-lg cntModalPoliza",
    id: "polizaModal",
    tabIndex: -1,
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-dialog modal-dialog-centered"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React.createElement(Header, {
    poliza: poliza
  })), /*#__PURE__*/React.createElement("div", {
    className: "modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("h5", null, "Datos de P\xF3liza"), /*#__PURE__*/React.createElement(DetailTable, {
    poliza: poliza
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Item Asegurado"), /*#__PURE__*/React.createElement(ItemAsegurado, {
    itemAsegurado: poliza.item_asegurado
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "M\xE9todo de Pago"), /*#__PURE__*/React.createElement(PaymentMethod, {
    poliza: poliza
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("h5", null, "Datos Contratante"), /*#__PURE__*/React.createElement(ClientTable, {
    user: poliza.contratante
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Datos Asegurado"), /*#__PURE__*/React.createElement(ClientTable, {
    user: poliza.asegurado
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Datos Beneficiario"), /*#__PURE__*/React.createElement(ClientTable, {
    user: poliza.beneficiario
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/React.createElement(Footer, {
    polizaId: poliza === null || poliza === void 0 ? void 0 : poliza.id
  })))));
};

export default ModalPoliza;